import { BaseButton } from '@/shared/components'
import { PageTitle } from '@/shared/components/PageTitle/PageTitle'
import { useIsMobile } from '@/shared/utils/useIsMobile/useIsMobile'
import { DownloadIcon, Plus } from 'lucide-react'

type Props = {
  setModalAddDevice: (value: boolean) => void
  onDownloadClick: () => void
}

export const DevicesHeader = ({ setModalAddDevice, onDownloadClick }: Props) => {
  const isMobile = useIsMobile()

  return (
    <div className="flex md:flex-row flex-col justify-between gap-6 mb-[14px] md:mb-8">
      <PageTitle title="Устройства" />
      <div className="flex items-center gap-[10px]">
        <BaseButton
          variant="primary"
          padding="none"
          radius="md"
          className="!bg-light-purple hover:!bg-light-purple-hover hover:dark:!bg-primary-dark-hover dark:!bg-dark-purple !border-0 !ring-light-purple hover:!ring-light-purple-hover hover:dark:!ring-primary-dark-hover dark:!ring-dark-purple w-full md:w-[250px] !text-primary hover:dark:!text-white dark:!text-primary-dark"
          iconPosition="left"
          onClick={onDownloadClick}
          icon={<DownloadIcon />}
        >
          {isMobile ? 'Приложение' : 'Скачать приложение'}
        </BaseButton>
        <BaseButton
          variant="primary"
          padding="none"
          radius="md"
          className="w-full md:w-[260px]"
          iconPosition="left"
          icon={<Plus className="text-white" />}
          onClick={() => setModalAddDevice(true)}
        >
          {isMobile ? 'Добавить' : 'Добавить устройство'}
        </BaseButton>
      </div>
    </div>
  )
}
